/**
 * Google tag (gtag.js) helpers — gtag is loaded from index.html; SPA sends page_view on route changes.
 * Default ID matches index.html so analytics works even when VITE_GOOGLE_TAG_ID is unset in production CI.
 */

const DEFAULT_GOOGLE_TAG_ID = 'G-CGL3QXE74R';

export const GOOGLE_TAG_ID =
  import.meta.env.VITE_GOOGLE_TAG_ID?.trim() || DEFAULT_GOOGLE_TAG_ID;

export function isGtagConfigured(): boolean {
  return GOOGLE_TAG_ID.length > 0 && /^G-[A-Z0-9]+$/i.test(GOOGLE_TAG_ID);
}

/** Admin / internal surfaces — do not send GA4 page views */
export function isExcludedPathForGtag(pathname: string): boolean {
  if (pathname === '/admin-demo') return true;
  if (pathname === '/admin' || pathname.startsWith('/admin/')) return true;
  return false;
}

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/** Fire a GA4 page_view for SPA navigations (initial load + route changes). */
export function sendGtagPageView(fullPathWithQuery: string): void {
  if (!isGtagConfigured() || typeof window.gtag !== 'function') return;
  const pathname = fullPathWithQuery.split('?')[0] ?? '';
  if (isExcludedPathForGtag(pathname)) return;

  window.gtag('event', 'page_view', {
    page_path: fullPathWithQuery,
    page_location: window.location.href,
    page_title: document.title,
  });
}
